<template>
  <div>
    <el-dialog
      title="申请分批发货"
      :visible.sync="dialogVisible"
      width="90%"
      top="5vh"
      class="partShipment"
      @close="closeDialog"
    >
      <div>
        产品信息
      </div>
      <div class="table-box">
        <div v-for="(item, index) in newProductList" :key="index" class="table-item">
          <div class="table-title">
            <span>原收货地址： {{ item.address }}</span>
            <span>原运输方式： {{ item.modelOfShipping }}</span>
            <span>原承运商： {{ item.carrier }}</span>
          </div>
          <div class="table-inner">
            <el-table
              :data="item.productList"
              border
              class="w-full"
              show-summary
              :summary-method="getSummaries"
            >
              <el-table-column
                prop="itemIndex"
                label="序号"
                align="left"
                width="90"
              />
              <el-table-column prop="orderNumber" label="订单号" align="left" />
              <el-table-column
                prop="materialNumber"
                label="物品代码"
                align="left"
              />
              <el-table-column prop="productName" label="物品名称" align="left" />
              <el-table-column prop="productNum" label="数量" align="left" width="60px" />
              <el-table-column
                prop="productPriceSigle"
                label="实际结算单价"
                align="right"
                header-align="left"
                width="100px"
              />
              <el-table-column
                prop="settlementAmount"
                label="实际结算金额"
                align="right"
                header-align="left"
                width="100px"
              />
              <el-table-column
                prop="freightAttributeName"
                label="货运方式"
                align="left"
                width="100"
              />
              <el-table-column
                prop="expectedDeliveryDate"
                label="客户期望发货日"
                align="left"
                width="140"
              >
                <template v-slot="{row}">
                  {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="agreedDate"
                label="约定交付日期"
                align="left"
                width="140"
              >
                <template v-slot="{row}">
                  {{ row.agreedDate && row.agreedDate.substr(0,11) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="deliveryAddress"
                label="收货地址"
                align="left"
                width="200"
              />
              <el-table-column
                prop="modeOfShipping"
                label="运输方式"
                align="left"
                width="100"
              />
              <el-table-column
                prop="carrier"
                label="承运商"
                align="left"
                width="100"
              />
            </el-table>
          </div>
        </div>
      </div>
      <DialogAddressInnerProduct ref="DialogAddressInnerProductRef" :detail="true" />
      <div class="advanceMakeDeatail">
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否需要唛头：
              </div>
              <div class="rj-baseinfo__item">
                {{ markType === '1' ? '是' : '否' }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                {{ findContractInfoForPartialInvoiceMessage.authorizationEmail }}
              </div>
            </div>
          </div>
          <!--          <div class="rj-col-2">-->
          <!--            <div class="rj-baseinfo">-->
          <!--              <div class="rj-baseinfo__label">-->
          <!--                是否有特殊回单：-->
          <!--              </div>-->
          <!--              <div class="rj-baseinfo__item">-->
          <!--                {{ tshdType === '1' ? '是' : '否' }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <p>
        <span class="inline-block my-1">收货回执及到货验收要求：</span>
        {{ findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements }}
      </p>
      <p>
        <span>回执附件</span>
      </p>
      <!--   附件列表   -->
      <el-table
        :data="fileList"
        border
        class="w-full"
      >
        <el-table-column prop="receiptNum" label="回执单号" align="left" />
        <el-table-column prop="fileName" label="附件名称" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleShowFile(row)">
              {{ row.fileName }}
            </el-button>
          </template>
        </el-table-column>>
        <el-table-column prop="createBy" label="上传人" align="left" />
        <el-table-column prop="createTime" label="上传时间" align="left" />
        <el-table-column label="操作" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleShowFile(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <p>
        <span class="inline-block my-1">发货备注说明：</span>
        {{ findContractInfoForPartialInvoiceMessage.deliverRemark }}
      </p>
      <p>
        <span class="inline-block my-1">备注：</span>
        {{ findContractInfoForPartialInvoiceMessage.remark }}
      </p>
      <p>
        <span>历史审批意见</span>
      </p>
      <el-table :data="approveTableList" border class="w-full mt-2.5 mb-2.5">
        <el-table-column prop="approveUserInfo" label="审批人" align="left" width="170" />
        <el-table-column prop="approveComment" label="审批内容" align="left" />
        <el-table-column prop="approveTime" label="审批时间" align="left" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { MathAdd } from '@/libs/util';
import DialogAddressInnerProduct from '@/views/Chief/contract/common/DialogAddressInnerProduct.vue';
import {
  attachmentGetToken, receiptAttachmentGetDetailInfo, getReceiptAttachmentByPartialShipmentNum,
  getApproveLogByPartialId
} from '@/API';
export default {
  name: 'RequestMorePODetail',
  components: {
    DialogAddressInnerProduct
  },
  data () {
    return {
      dialogVisible: false,
      markType: '1',
      findContractInfoForPartialInvoiceMessage: {
        authorizationEmail: '',
        receiptArrivalAcceptanceRequirements: '',
        deliverRemark: '',
        remark: ''
      },
      tshdType: '',
      fileList: [],
      newProductList: [], // mock 产品列表数据
      downFileUrl: '',
      token: '',
      approveTableList: []
    };
  },
  methods: {
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      });
    },
    closeDialog () {
      this.dialogVisible = false;
    },
    // 每个表格的小计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },
    // 实际结算金额总计
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 查看文件
    handleShowFile (row) {
      const url = `${this.downFileUrl}/${row.fileToken}?Token=${this.token}`;
      window.open(url, '_blank');
    },
    openDialog (row) {
      receiptAttachmentGetDetailInfo(row.id).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.findContractInfoForPartialInvoiceMessage.authorizationEmail = json.data.authorizationEmail || '';
          this.findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements = json.data.receiptArrivalAcceptanceRequirements || '';
          this.findContractInfoForPartialInvoiceMessage.deliverRemark = json.data.deliverRemark || '';
          this.findContractInfoForPartialInvoiceMessage.remark = json.data.remark || '';
          this.markType = json.data.markType;
          this.lasterAddressId = json.data.receiptAddressId || null;
          this.newProductList = json.data.partialInvoiceAddressGroupList || [];
          this.dialogVisible = true;
          this.initToken();

          setTimeout(() => {
            this.$refs.DialogAddressInnerProductRef.setData(this.newProductList);
          }, 100);
          getReceiptAttachmentByPartialShipmentNum({ partialShipmentNum: row.deliveryNum }).then(fileRes => {
            const fileJson = fileRes.data;
            if (fileJson.status === '200') {
              this.fileList = fileJson.data || [];
            }
          });
          getApproveLogByPartialId({ partialId: row.id }).then((res) => {
            const { data, status } = res.data;
            if (status === '200') {
              this.approveTableList = data || [];
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.partShipment p {
  margin: 5px 0;
}
.required-tip{
  color: red;
}
::v-deep .el-dialog__body{
  padding: 16px;
  height: 78vh;
  overflow-y: auto;
}
.table-box{
  .table-item{
    margin-top: 16px;
    border: 1px solid #EBEEF5;
    .table-title{
      padding: 8px 16px 8px 8px;
      span{
        margin-right: 32px;
      }
    }
  }
}
.action-box{
  margin-top: 16px;
  span{
    margin-left: 16px;
  }
}
</style>
